import React from 'react';

import { Skeleton } from '@mui/material';

import { titleStyle } from '@styles/common';

/** 포트폴리오 상세 > 기본정보 > 포트폴리오 현황 스켈레톤 */
const PortfolioSummarySkeleton = () => {
  return (
    <>
      <div css={titleStyle}>
        <Skeleton variant="text" width={120} />
      </div>
      <Skeleton
        variant="rectangular"
        height={154}
        sx={{
          borderRadius: '10px',
          boxShadow: '0px 0px 20px 0px rgba(206, 208, 214, 0.5)',
          marginBottom: '40px',
        }}
      />
    </>
  );
};

export default PortfolioSummarySkeleton;
